/**
 * @generated SignedSource<<746a783ca3dca300e1134af869a4db20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserNotificationPayloadEnum = "ACTIVITY_FEED" | "ITEM_EVENT" | "MESSAGE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useGetAllUnviewedNotifications_userNotifications$data = {
  readonly earlier: {
    readonly all: ReadonlyArray<{
      readonly notificationType: UserNotificationPayloadEnum | null;
      readonly payload: {
        readonly buyerMember?: {
          readonly hasUnviewedTag: boolean | null;
        } | null;
        readonly serviceId?: string | null;
        readonly type?: string | null;
        readonly unviewedTag?: {
          readonly serviceId: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly latest: {
    readonly all: ReadonlyArray<{
      readonly notificationType: UserNotificationPayloadEnum | null;
      readonly payload: {
        readonly buyerMember?: {
          readonly hasUnviewedTag: boolean | null;
        } | null;
        readonly serviceId?: string | null;
        readonly type?: string | null;
        readonly unviewedTag?: {
          readonly serviceId: string | null;
        } | null;
      } | null;
    } | null> | null;
    readonly messages: ReadonlyArray<{
      readonly buyerMember: {
        readonly hasUnviewedTag: boolean | null;
      } | null;
      readonly serviceId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useGetAllUnviewedNotifications_userNotifications";
};
export type useGetAllUnviewedNotifications_userNotifications$key = {
  readonly " $data"?: useGetAllUnviewedNotifications_userNotifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetAllUnviewedNotifications_userNotifications">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNotificationsTag",
    "kind": "LinkedField",
    "name": "unviewedTag",
    "plural": false,
    "selections": [
      (v0/*: any*/)
    ],
    "storageKey": null
  }
],
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Member",
    "kind": "LinkedField",
    "name": "buyerMember",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasUnviewedTag",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotification",
  "kind": "LinkedField",
  "name": "all",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notificationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "payload",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "FavoriteNotification",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "ActivityFeedElement",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Conversation",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetAllUnviewedNotifications_userNotifications",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNotificationsBucket",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Conversation",
          "kind": "LinkedField",
          "name": "messages",
          "plural": true,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNotificationsBucket",
      "kind": "LinkedField",
      "name": "earlier",
      "plural": false,
      "selections": [
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UserNotifications",
  "abstractKey": null
};
})();

(node as any).hash = "e52f481a069e8a714bf39349eac511fe";

export default node;
